// extracted by mini-css-extract-plugin
export default {"square":"SerpPresenceTableExpandRow_square__1-zu1"};